import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSession } from './authClient.js';
import { useTRPC } from './trpc.js';

// Reached before a client is chosen, or onboarding itself.
const UNGATED = ['/login', '/invites', '/onboarding'];

/**
 * A client with no ad account yet (the backend's needsOnboarding) is sent to onboarding. True
 * while that is unknown or redirecting, so a gated page never renders before the redirect.
 */
export function useOnboardingGate(): boolean {
  const { data: session } = useSession();
  const pathname = useLocation({ select: (location) => location.pathname });
  const navigate = useNavigate();
  const trpc = useTRPC();
  const gated =
    !!session && !UNGATED.some((path) => pathname === path || pathname.startsWith(`${path}/`));
  const client = useQuery({ ...trpc.auth.currentClient.queryOptions(), enabled: gated });
  const redirect = gated && client.data?.needsOnboarding === true;

  useEffect(() => {
    if (redirect) void navigate({ to: '/onboarding', replace: true });
  }, [redirect, navigate]);

  return redirect || (gated && client.isPending);
}
